export const dataConstants = {
  userType: ["B2B", "B2C"],
  status: [true, false],
};
